import React, { useEffect } from "react";
import Slider from "@material-ui/core/Slider";
import {
  GetYearsSlider,
  SetYearSelected,
} from "../../services/actions/RoadAction";
import { withStyles } from "@material-ui/core/styles";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import $ from "jquery";
import { isNull } from "../../shared/utils/objectExtensions";
import { resetDataType } from "../../services/actions/GisAction";

// Classes used by Leaflet to position controls
const POSITION_CLASSES = {
  bottomleft: "leaflet-bottom leaflet-left",
  bottomright: "leaflet-bottom leaflet-right",
  topleft: "leaflet-top leaflet-left",
  topright: "leaflet-top leaflet-right",
};

const DPYearSlider = ({
  userFilter,
  position,
  dpYears,
  GetYearsSliderData,
  yearFilter,
  SetYearFilter,
  showTopContent,
}) => {
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    SetYearFilter(newValue);
    dispatch(resetDataType());
  };

  const correctActiveLabels = () => {
    var labels = $(".MuiSlider-markActive");
    for (let i = 0; i < labels.length; i++) {
      const label = labels[i];
      $(label).removeClass("real-active");
      if (i == labels.length - 1) {
        $(label).addClass("real-active");
      }
    }

    var points = $(".MuiSlider-markLabelActive");
    for (let i = 0; i < points.length; i++) {
      const point = points[i];
      $(point).removeClass("real-active");
      if (i == points.length - 1) {
        $(point).addClass("real-active");
      }
    }
  };

  useEffect(() => {
    if (userFilter) {
      GetYearsSliderData();
    }
  }, [userFilter]);

  useEffect(() => {
    if (dpYears) {
      const years = dpYears.map(d => Number(d.year));
      const currentYear = moment().year();
      const _yearFilter = yearFilter?Number(yearFilter):0;
      if (years.indexOf(_yearFilter) >= 0) {
        SetYearFilter(_yearFilter);
      } else if (years.indexOf(currentYear) >= 0) {
        SetYearFilter(currentYear);
      } else if (years.length === 1) {
        SetYearFilter(years[0]);
      } else {
        SetYearFilter(currentYear); // 既存
      }
      correctActiveLabels();
    }
  }, [dpYears]);

  useEffect(() => {
    correctActiveLabels();
  }, [yearFilter]);

  let marks = [];
  if (!isNull(dpYears)) {
    dpYears.forEach((x) => {
      let dataType = "";
      if (x.isPredict && !x.isActual) {
        dataType = "Predicted";
      } else if (x.isPredict && x.isActual) {
        dataType = "Actual / Predicted";
      } else if (!x.isPredict) { // MEMO: isActualは意図的にtrue判定を行わない(Actual/Predicted判定のみに使用)
        dataType = "Actual";
      } else {
        dataType = "Unknonw";
      }

      marks.push({
        value: x.year,
        label: `${x.year} (${dataType})`,
        dataType: x.dataType,
      })
    })
  };

  const marksRange = marks.length ? marks[marks.length -1].value - marks[0].value + 1 : 0

  const positionClass =
    (position && POSITION_CLASSES[position]) || POSITION_CLASSES.topleft;
  return (
    <div className={positionClass}>
      <div className="leaflet-control">
        {marks?.length ? (
          <PrettoSlider
            style={{
              marginTop: "10px",
              marginLeft: "50px",
              width: marks.length === marksRange
                ? `${(50 + 5 * marks.length) * marks.length}px`
                : `${(50 + 5 * marksRange) * marksRange}px`
            }}
            defaultValue={Number(marks[0]?.value)}
            valueLabelDisplay="off"
            value={yearFilter}
            marks={marks}
            min={Number(marks[0].value)}
            max={Number(marks[marks.length - 1].value)}
            step={1}
            onChange={handleChange}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

const PrettoSlider = withStyles({
  root: {
    color: "#fff",
    height: 6,
    "& .MuiSlider-mark": {
      width: "20px",
      height: "20px",
      marginLeft: "-10px",
      top: "5px",
      borderRadius: "50%",
      border: "2px solid #d3d3d3",
    },
    "& .MuiSlider-markActive": {
      border: "2px solid #d3d3d3",
      width: "18px",
      height: "18px",
      opacity: "1",
      backgroundColor: "#fff",
    },
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#E28020",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: "black",
  },
  rail: {
    height: 8,
    borderRadius: 4,
    opacity: 0.8,
    backgroundColor: "black",
  },
})(Slider);

export default connect(
  (state) => ({
    dpYears: state.road.dpYears,
    userFilter: state.road.userFilter,
    yearFilter: state.road.yearFilter,
    showTopContent: state.gis.showTopContent,
  }),
  (dispatch) => ({
    GetYearsSliderData: () => dispatch(GetYearsSlider()),
    SetYearFilter: (year) => dispatch(SetYearSelected(year)),
  })
)(DPYearSlider);
